// extracted by mini-css-extract-plugin
module.exports = {"bottomDescription":"BottomDetails_bottomDescription__3q3vR"};